import { ApiCreateCategory, ApiDeleteCategory, ApiGetCategoryById, ApiGetCategoryList, ApiUpdateCategory } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function CategoryService() {
    const { showFail } = useModal()

    const { fetch: apiGetCategoryList } = useFetch(ApiGetCategoryList)
    const { fetch: apiDeleteCategory } = useFetch(ApiDeleteCategory)
    const { fetch: apiCreateCategory } = useFetch(ApiCreateCategory)
    const { fetch: apiGetCategoryById } = useFetch(ApiGetCategoryById)
    const { fetch: apiUpdateCategory } = useFetch(ApiUpdateCategory)

    const fetchCategoryList = async (categoryName, status, pageSize, pageIndex) => {
        const res = await apiGetCategoryList({
            data: {
                categoryName,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteCategory = async (categoryId, status) => {
        const res = await apiDeleteCategory({
            data: {
                categoryId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateCategory = async (categoryName) => {
        const res = await apiCreateCategory({
            data: {
                categoryName
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateCategory = async (categoryId, categoryName) => {
        const res = await apiUpdateCategory({
            data: {
                categoryId,
                categoryName
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCategoryById = async (categoryId) => {
        const res = await apiGetCategoryById({
            data: {
                categoryId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchCategoryList,
        fetchDeleteCategory,
        fetchCreateCategory,
        fetchUpdateCategory,
        fetchCategoryById
    }
}